var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      style: { "z-index": _vm.zIndex || 1050 },
      attrs: { id: "promotionadd", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-xl",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _vm.countData === 0
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-danger text-center p-xxs m-b-xs"
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "m-b-none" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { path: "/products-new" } } },
                            [_vm._v("こちら")]
                          ),
                          _vm._v("から商品登録をしてください。")
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    ref: "promotionModal",
                    staticClass: "panel products-table",
                    staticStyle: { position: "relative" }
                  },
                  [
                    _c("base-table", {
                      ref: "promotionTable",
                      attrs: {
                        url: "PromotionProduct/available",
                        extraUrl: ["Product/get-image-name"],
                        extraUrlMode: true,
                        columns: _vm.promotionColumns,
                        isSearchable: true,
                        needExtraData: true,
                        loadingTableMode: true,
                        clientMode: true,
                        checkedItems: _vm.checkedItems,
                        isShowBtnBulkCreate: true
                      },
                      on: {
                        countData: function($event) {
                          _vm.countData = $event
                        },
                        extraData: function($event) {
                          _vm.extraData = $event
                        },
                        keyword: _vm.onHandleSearch,
                        zIndex: function($event) {
                          _vm.zIndex = $event
                        },
                        checkBoxAll: _vm.checkBoxAll,
                        bulkAdd: _vm.bulkAddPromotion
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "checkBoxAll",
                          fn: function(props) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.checkedItems,
                                    expression: "checkedItems"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: props.rowData.asin,
                                  checked: Array.isArray(_vm.checkedItems)
                                    ? _vm._i(
                                        _vm.checkedItems,
                                        props.rowData.asin
                                      ) > -1
                                    : _vm.checkedItems
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.checkedItems,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = props.rowData.asin,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.checkedItems = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.checkedItems = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.checkedItems = $$c
                                      }
                                    },
                                    _vm.refreshCheckAll
                                  ]
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "image",
                          fn: function(props) {
                            return [
                              _c(
                                "loading-block",
                                {
                                  attrs: {
                                    value: props.rowData.image,
                                    type: "image"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "product-img",
                                    attrs: {
                                      src: _vm.prepareImgSrc(
                                        props.rowData.image
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "productName",
                          fn: function(props) {
                            return [
                              _c(
                                "loading-block",
                                {
                                  attrs: {
                                    value: props.rowData.productName,
                                    type: "string"
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text--underline",
                                      attrs: {
                                        href:
                                          "https://www.amazon.co.jp/gp/offer-listing/" +
                                          props.rowData.asin,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(props.rowData.productName) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "action",
                          fn: function(props) {
                            return [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning",
                                  on: {
                                    click: function($event) {
                                      _vm.addPromotion(props.rowData)
                                    }
                                  }
                                },
                                [_vm._v("追加")]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row m-b-sm" }, [
                      _c("div", { staticClass: "flexbox justify-right" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-warning ver-middle w-120 mr-r-10",
                            on: { click: _vm.onHandleReload }
                          },
                          [
                            _vm._v(
                              "\n                  再読み込み\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            attrs: { "data-dismiss": "modal" },
                            on: {
                              click: function($event) {
                                _vm.$emit("close")
                              }
                            }
                          },
                          [
                            _c(
                              "button",
                              { staticClass: "btn ver-middle w-120" },
                              [_vm._v("閉じる")]
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6335b32a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6335b32a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/promotion/PromotionAdd.vue
// module id = null
// module chunks = 